<template>
	<div></div>
</template>

<script>
/* begin olark code */
//;(function(o,l,a,r,k,y){if(o.olark)return; r="script";y=l.createElement(r);r=l.getElementsByTagName(r)[0]; y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r); y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)}; y.extend=function(i,j){y("extend",i,j)}; y.identify=function(i){y("identify",k.i=i)}; y.configure=function(i,j){y("configure",i,j);k.c[i]=j}; k=y._={s:[],t:[+new Date],c:{},l:a}; })(window,document,"static.olark.com/jsclient/loader.js");
//olark.configure('system.hb_custom_style', {
//	general: {
//		fonts: ['Montserrat', 'sans-serif'],
//		secondaryColor: '#3a70c7',
//	}
//});
//olark.configure('system.hb_primary_color', '#3e78d3');
//olark.configure('system.hb_secondary_color', '#3e78d3');
//olark.identify('1111-182-10-2603');
/* end olark code */

/* begin crisp code */
window.$crisp=[];window.CRISP_WEBSITE_ID="a063ddb0-94d0-49d6-aef6-70e07fed4ca5";(function(){
	var d=document;
	var s=d.createElement("script");
	s.src="https://client.crisp.chat/l.js";
	s.async=1;
	d.getElementsByTagName("head")[0].appendChild(s);
})();
/* end crisp code */

export default {};
</script>

<style>
body #olark-wrapper.olark-dark-theme .olark-top-bar {
	background: url('~@/assets/img/button-back-hosts.png') !important;
	background-size: cover !important;
}
body #olark-container .olark-survey-form .olark-survey-form-info-message {
	color: #d7d9dc !important;
	display: none !important;
}
body #olark-container .olark-survey-form .olark-survey-form-req-icon svg {
	margin-top: -10px !important;
}
body #olark-container .olark-survey-form .olark-button {
	background: url('~@/assets/img/button-back-game.png') !important;
	background-size: cover !important;
	margin-bottom: 10px !important;
}
body #olark-wrapper.olark-dark-theme .olark-launch-button {
	background: url('~@/assets/img/button-back-servers.png') !important;
	background-size: cover !important;
}
body #olark-wrapper span {
    font-size: 16px;
    font-weight: bold;
}
</style>